import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Tooltip } from 'ui-components/components/tooltip';
import { TooltipContent } from 'ui-components/components/tooltip/tooltip-content';

import messages from '../messages';
import { emptyArray } from 'ui-components/default-props/empty';
import style from '../../grid-page.module.less';

const name = <FormattedMessage {...messages.aliasColumnHeader} />;

export default {
  getMessageDescriptor: () => messages.aliasColumnHeader,
  name,
  render: (data) => {
    const aliases = data.productAliases || emptyArray;
    if (aliases.length > 1) {
      return (
        <Tooltip position='bottom'>
          <TooltipContent>
            <div className={style['tooltip-text']}>
              {aliases.map(({ aliasSKU }) => (
                <p key={`alias-sku-${aliasSKU}`}>{aliasSKU}</p>
              ))}
            </div>
          </TooltipContent>
          <div>
            <FormattedMessage {...messages.pluralAliases} values={{ number: aliases.length }} />
          </div>
        </Tooltip>
      );
    }

    return aliases.length === 1 ? aliases[0].aliasSKU : '';
  },
};
